import { useMemo } from 'react';
import { isNullish } from 'remeda';
import { useMergeTargetSearch } from 'src/components/MergeTargetPicker/use-merge-target-search';
import { Address } from 'src/graphql';
import { ConditionInput, EntityNames } from 'src/graphql/types';

/** Sites of the origin's partner, the origin itself excluded. */
export const useSiteTargetSearch = (origin: Address | null) => {
  const partnerId = origin?.partnerId;
  const originId = origin?.addressId;

  const conditions = useMemo(() => {
    const list: ConditionInput[] = [];

    if (!isNullish(partnerId)) {
      list.push({ attribute: 'partnerId', operator: '=', value: String(partnerId) });
    }

    if (originId) {
      list.push({ attribute: 'addressId', operator: '!=', value: originId });
    }

    return list;
  }, [partnerId, originId]);

  return useMergeTargetSearch({ entityName: EntityNames.Site, conditions });
};
